import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetJobtypes } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';

// export columns for the route
export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('Κωδικός Εργασίας'), fieldType: 'TEXT' },
    { fieldName: 'code', fieldTitle: t('Κωδικός'), fieldType: 'TEXT' },
    { fieldName: 'description', fieldTitle: t('Περιγραφή'), fieldType: 'TEXT' },
    { fieldName: 'detailedDescription', fieldTitle: t('Αναλυτική Περιγραφή'), fieldType: 'TEXT' },
    { fieldName: 'chargingCode', fieldTitle: t('Κωδικός Χρέωσης'), fieldType: 'TEXT' },
    { fieldName: 'materialId', fieldTitle: t('Υλικό'), fieldType: 'TEXT' },
    { fieldName: 'isActiveText', fieldTitle: t('Ενεργό'), fieldType: 'TEXT' },
    { fieldName: 'firstDate', fieldTitle: t('Ημερ. Έναρξης'), fieldType: 'DATE' },
    // { fieldName: 'lastDate', fieldTitle: t('Ημερ. Λήξης'), fieldType: 'DATE' },
    // { fieldName: 'firstUser', fieldTitle: t('Χρήστης Δημιουργίας'), fieldType: 'TEXT' },
    // { fieldName: 'lastUser', fieldTitle: t('Τελευταίος Χρήστης'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetJobtypes, {
      onCompleted: transformData,
      fetchPolicy: 'network-only',
    });

    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

    function transformData(data) {
      const recs = data.getJobtypes.data.map((v) => ({
        ...v,
        isActiveText: v.isActive ? 'ΝΑΙ' : 'ΟΧΙ',
      }));

      const trsData = {
        getJobtypes: {
          data: recs,
          recordCount: data?.getJobtypes?.recordCount,
        },
      };

      setResult([get, { loading, data: trsData }]);
    }

    return result;
  }

  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };

  await exportXlsModal({
    apolloClient: client,
    exportFileName: t('Εξαγωγή Εργασιών'),
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
